import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Loader,
  LoaderWrapper,
} from '~/components/chat-question-response/ChatQuestionResponse.styles';
import { useEnrichedConditions } from '~/hooks/use-enriched-conditions/useEnrichedConditions';
import { ScenarioData } from '~/stores/use-chat/assistant-response.type';
import { MappedDominosByPeriod } from '~/utils/domino-utils/domino-utils';
import { DominoWidget } from '~/widgets/domino-widget/DominoWidget';
import { ScenarioWidget } from '~/widgets/scenario-widget/ScenarioWidget';

import { useMappedDominos } from './hooks/use-mapped-dominos/useMappedDominos';

export interface DominoMessageProps {
  data: ScenarioData;
}

export const DominoMessage = ({ data }: DominoMessageProps) => {
  const { t } = useTranslation('intel');
  const { conditions } = useEnrichedConditions(data.conditions);
  const showScenarioWidget = data.entities.length === 1;
  const { loading, error, dominos, mappedDominosByPeriod } = useMappedDominos({
    data,
    shouldMapDominos: !showScenarioWidget,
  });

  if (error) {
    return <p>{t('intel:empty')}</p>;
  }

  if (loading || !dominos || (!showScenarioWidget && !mappedDominosByPeriod)) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  if (showScenarioWidget) {
    const [domino] = dominos;
    return (
      domino && (
        <ScenarioWidget
          conditions={conditions}
          entityTag={domino.entity}
          prediction={domino.prediction}
          episodes={domino.episodes}
        />
      )
    );
  }

  return (
    <DominoWidget
      mappedDominosByPeriod={mappedDominosByPeriod as MappedDominosByPeriod}
      dominos={dominos}
      conditions={conditions}
    />
  );
};
